import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Header from "./components/Header";
import Hero from "./components/Hero";
import BurnForm from "./components/BurnForm";
import LaunchBoard from "./components/LaunchBoard";
import LaunchToken from "./components/LaunchToken";
import BurnHistory from "./components/BurnHistory";
import WhyStamp from "./components/WhyStamp";
import VerifySection from "./components/VerifySection";
import Footer from "./components/Footer";
import { WalletProvider } from "./context/WalletContext";

const Home = () => {
  useEffect(() => {
    document.title = "ZSTAMP — Burn it, keep the receipt | BNB Chain × Zcash";
  }, []);
  return (
    <div className="App grain">
      <Header />
      <main>
        <Hero />
        <BurnForm />
        <LaunchToken />
        <LaunchBoard />
        <BurnHistory />
        <WhyStamp />
        <VerifySection />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <WalletProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" theme="dark" />
    </WalletProvider>
  );
}

export default App;
